// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_math = require("rescript/lib/js/js_math.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentPatternBuilder$ReactHooksTemplate = require("./ImportEnrichmentPatternBuilder.res.js");

function newLookupRow(param) {
  return {
          id: ImportEnrichmentRuleTypes$ReactHooksTemplate.generateNodeId("lm"),
          source: "",
          target: ""
        };
}

function parseLookupMapText(text) {
  return Belt_List.fromArray(Belt_Array.map(text.split("\n"), (function (line) {
                    var trimmed = line.trim();
                    if (trimmed === "") {
                      return newLookupRow();
                    }
                    if (!trimmed.includes("=")) {
                      return newLookupRow();
                    }
                    var eqIndex = trimmed.indexOf("=");
                    var source = trimmed.substring(0, eqIndex).trim();
                    var target = trimmed.substring(eqIndex + 1 | 0, trimmed.length).trim();
                    return {
                            id: ImportEnrichmentRuleTypes$ReactHooksTemplate.generateNodeId("lm"),
                            source: source,
                            target: target
                          };
                  })));
}

function serializeLookupMapRows(rows) {
  return Belt_List.toArray(Belt_List.map(Belt_List.keep(rows, (function (row) {
                          if (row.source.trim() !== "") {
                            return row.target.trim() !== "";
                          } else {
                            return false;
                          }
                        })), (function (row) {
                      return row.source.trim() + "=" + row.target.trim();
                    }))).join("\n");
}

function ensureLookupRows(rows) {
  if (Belt_List.length(rows) === 0) {
    return {
            hd: newLookupRow(),
            tl: /* [] */0
          };
  } else {
    return rows;
  }
}

function isLookupRowEmpty(row) {
  if (row.source.trim() === "") {
    return row.target.trim() === "";
  } else {
    return false;
  }
}

function canRemoveLookupRow(rows, row) {
  if (Belt_List.length(rows) > 1) {
    return true;
  } else {
    return !isLookupRowEmpty(row);
  }
}

function removeLookupRowAt(rows, rowId) {
  var next = Belt_List.keep(rows, (function (row) {
          return row.id !== rowId;
        }));
  return ensureLookupRows(Belt_List.length(next) === 0 ? ({
                  hd: newLookupRow(),
                  tl: /* [] */0
                }) : next);
}

function lookupCompleteRows(rows) {
  return Belt_List.keep(rows, (function (row) {
                if (row.source.trim() !== "") {
                  return row.target.trim() !== "";
                } else {
                  return false;
                }
              }));
}

function lookupPartialRows(rows) {
  return Belt_List.keep(rows, (function (row) {
                var hasSource = row.source.trim() !== "";
                var hasTarget = row.target.trim() !== "";
                return hasSource !== hasTarget;
              }));
}

function lookupDuplicateSources(rows) {
  var counts = {};
  Belt_List.forEach(lookupCompleteRows(rows), (function (row) {
          var source = row.source.trim();
          var n = Js_dict.get(counts, source);
          var current = n !== undefined ? n : 0;
          counts[source] = current + 1 | 0;
        }));
  return Belt_List.fromArray(Belt_Array.keepMap(Js_dict.entries(counts), (function (param) {
                    if (param[1] > 1) {
                      return param[0];
                    }
                    
                  })));
}

function lookupHasValidMappings(rows) {
  if (Belt_List.length(lookupCompleteRows(rows)) > 0 && Belt_List.length(lookupPartialRows(rows)) === 0) {
    return Belt_List.length(lookupDuplicateSources(rows)) === 0;
  } else {
    return false;
  }
}

var templateTokenRe = new RegExp("(\\$\\{[^}]+\\})");

function parseTemplateParts(text) {
  if (text.length === 0) {
    return /* [] */0;
  } else {
    return Belt_List.fromArray(Belt_Array.map(Belt_Array.keepMap(text.split(templateTokenRe), (function (segment) {
                          if (segment !== undefined && segment.length > 0) {
                            return segment;
                          }
                          
                        })), (function (segment) {
                      if (!(segment.length >= 3 && segment.startsWith("${") && segment.endsWith("}"))) {
                        return {
                                TAG: "TextPart",
                                _0: segment
                              };
                      }
                      var path = segment.substring(2, segment.length - 1 | 0);
                      return {
                              TAG: "FieldPart",
                              _0: path
                            };
                    })));
  }
}

function templateHumanPreview(fieldOptions, text) {
  if (text.trim() === "") {
    return "…";
  } else {
    return Belt_List.toArray(Belt_List.map(parseTemplateParts(text), (function (part) {
                        if (part.TAG === "TextPart") {
                          return part._0;
                        }
                        var label = ImportEnrichmentRuleTypes$ReactHooksTemplate.pathDisplayLabel(fieldOptions, part._0);
                        return "[" + label + "]";
                      }))).join("");
  }
}

function templateInvalidPaths(fieldOptions, text) {
  return Belt_List.keepMap(parseTemplateParts(text), (function (part) {
                if (part.TAG === "TextPart") {
                  return ;
                }
                var path = part._0;
                if (ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, path)) {
                  return ;
                } else {
                  return path;
                }
              }));
}

function presetToMatchType(preset) {
  switch (preset) {
    case "ExtractFirstNumber" :
        return "preset_number";
    case "ExtractBeforeDelimiter" :
        return "preset_before";
    case "ExtractAfterDelimiter" :
        return "preset_after";
    case "ExtractCustom" :
        return "preset_custom";
    
  }
}

function matchTypeToPreset(value) {
  switch (value) {
    case "preset_after" :
        return "ExtractAfterDelimiter";
    case "preset_before" :
        return "ExtractBeforeDelimiter";
    case "preset_number" :
        return "ExtractFirstNumber";
    default:
      return "ExtractCustom";
  }
}

function extractPresetLabel(preset) {
  switch (preset) {
    case "ExtractFirstNumber" :
        return "First number in the text";
    case "ExtractBeforeDelimiter" :
        return "Text before a character";
    case "ExtractAfterDelimiter" :
        return "Text after a character";
    case "ExtractCustom" :
        return "Custom pattern (Advanced)";
    
  }
}

function escapeRegex(text) {
  return text.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\$&");
}

function applyExtractPreset(row, preset) {
  var matchType = presetToMatchType(preset);
  switch (preset) {
    case "ExtractFirstNumber" :
        var newrecord = Caml_obj.obj_dup(row);
        newrecord.regexBuilderMatchType = matchType;
        newrecord.regexMode = "Advanced";
        newrecord.regexGroup = "1";
        newrecord.regexPattern = "(\\d+)";
        return newrecord;
    case "ExtractBeforeDelimiter" :
        var newrecord$1 = Caml_obj.obj_dup(row);
        newrecord$1.regexBuilderMatchType = matchType;
        newrecord$1.regexMode = "Advanced";
        newrecord$1.regexGroup = "1";
        newrecord$1.regexPattern = "";
        return newrecord$1;
    case "ExtractAfterDelimiter" :
        var newrecord$2 = Caml_obj.obj_dup(row);
        newrecord$2.regexBuilderMatchType = matchType;
        newrecord$2.regexMode = "Advanced";
        newrecord$2.regexGroup = "1";
        newrecord$2.regexPattern = "";
        return newrecord$2;
    case "ExtractCustom" :
        var newrecord$3 = Caml_obj.obj_dup(row);
        newrecord$3.regexBuilderMatchType = matchType;
        newrecord$3.regexMode = "Advanced";
        return newrecord$3;
    
  }
}

function compilePresetPattern(row) {
  var preset = matchTypeToPreset(row.regexBuilderMatchType);
  switch (preset) {
    case "ExtractFirstNumber" :
        return "(\\d+)";
    case "ExtractBeforeDelimiter" :
        var delimiter = row.regexBuilderText.trim();
        if (delimiter === "") {
          return "";
        } else {
          return "^(.+)" + escapeRegex(delimiter);
        }
    case "ExtractAfterDelimiter" :
        var delimiter$1 = row.regexBuilderText.trim();
        if (delimiter$1 === "") {
          return "";
        } else {
          return escapeRegex(delimiter$1) + "(.+)";
        }
    case "ExtractCustom" :
        return row.regexPattern;
    
  }
}

function compileExtractPattern(row) {
  if (row.regexMode === "Simple") {
    var n = Belt_Int.fromString(row.regexGroup.trim());
    var compiled = ImportEnrichmentPatternBuilder$ReactHooksTemplate.compileCapturePattern(ImportEnrichmentPatternBuilder$ReactHooksTemplate.simpleMatchTypeFromString(row.regexBuilderMatchType), row.regexBuilderText, n !== undefined ? n : 1);
    if (compiled !== undefined) {
      return compiled;
    } else {
      return row.regexPattern;
    }
  }
  if (!row.regexBuilderMatchType.startsWith("preset_")) {
    return row.regexPattern;
  }
  var compiled$1 = compilePresetPattern(row);
  if (compiled$1 === "") {
    return row.regexPattern;
  } else {
    return compiled$1;
  }
}

function currentExtractPreset(row) {
  if (row.regexMode === "Simple") {
    return "ExtractCustom";
  } else {
    return matchTypeToPreset(row.regexBuilderMatchType);
  }
}

function legacySimplePatternSummary(row) {
  var matchLabel = ImportEnrichmentPatternBuilder$ReactHooksTemplate.simpleMatchTypeLabelForCapture(ImportEnrichmentPatternBuilder$ReactHooksTemplate.simpleMatchTypeFromString(row.regexBuilderMatchType));
  var text = row.regexBuilderText.trim() === "" ? "…" : "\"" + row.regexBuilderText + "\"";
  return matchLabel + " " + text;
}

function extractWorkedExample(sample, pattern, group) {
  if (sample.trim() === "" || pattern.trim() === "") {
    return ;
  }
  try {
    var regex = new RegExp(pattern);
    var result = regex.exec(sample);
    if (result === null) {
      return "No match found in \"" + sample + "\"";
    }
    var index = Belt_Int.fromString(group.trim());
    if (index === undefined) {
      return ;
    }
    var captureNullable = Belt_Array.get(result, index);
    if (captureNullable === undefined) {
      return ;
    }
    var captureNullable$1 = Caml_option.valFromOption(captureNullable);
    if (!(captureNullable$1 == null)) {
      return "From \"" + sample + "\" → \"" + captureNullable$1 + "\"";
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function targetDataType(fieldOptions, targetKind, targetField) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByTarget(fieldOptions, targetKind, targetField);
  if (field !== undefined) {
    return field.dataType;
  } else {
    return "TextType";
  }
}

function isBooleanLikeList(options) {
  if (options.length === 2) {
    if (Belt_Array.some(options, (function (o) {
              return o.toLowerCase() === "yes";
            }))) {
      return true;
    } else {
      return Belt_Array.some(options, (function (o) {
                    return o.toLowerCase() === "true";
                  }));
    }
  } else {
    return false;
  }
}

function methodTierForTarget(dataType, valueType) {
  switch (dataType) {
    case "DateType" :
        switch (valueType) {
          case "Literal" :
          case "CopyPath" :
              return "PrimaryTransform";
          default:
            return "OtherTransform";
        }
    case "ListType" :
        switch (valueType) {
          case "Literal" :
          case "CopyPath" :
          case "LookupTable" :
              return "PrimaryTransform";
          default:
            return "OtherTransform";
        }
    case "NumberType" :
        switch (valueType) {
          case "Template" :
              return "OtherTransform";
          default:
            return "PrimaryTransform";
        }
    default:
      if (valueType === "DateDiffDays") {
        return "OtherTransform";
      } else {
        return "PrimaryTransform";
      }
  }
}

function uncommonMethodMessage(fieldOptions, targetKind, targetField, valueType) {
  var dataType = targetDataType(fieldOptions, targetKind, targetField);
  if (methodTierForTarget(dataType, valueType) !== "OtherTransform") {
    return ;
  }
  switch (dataType) {
    case "DateType" :
        if (valueType === "DateDiffDays") {
          return "This stores a number of days, not a date. Consider using a number field instead.";
        } else {
          return "This transform is uncommon for date fields. Fixed value or Copy is usually simpler.";
        }
    case "ListType" :
        switch (valueType) {
          case "DateDiffDays" :
              break;
          case "RegexCapture" :
          case "Template" :
              return "This may produce a value outside the allowed list for this field.";
          default:
            return "This transform is less common for the selected field type.";
        }
        break;
    case "NumberType" :
        switch (valueType) {
          case "DateDiffDays" :
              break;
          case "Template" :
              return "Combined text is uncommon for number fields.";
          default:
            return "This transform is less common for the selected field type.";
        }
        break;
    default:
      
  }
  if (valueType === "DateDiffDays") {
    return "Days between dates is usually saved to a number field.";
  } else {
    return "This transform is less common for the selected field type.";
  }
}

function partitionTransformMethods(dataType, selected, methods) {
  var primary = Belt_List.keep(methods, (function (method) {
          if (method === selected) {
            return true;
          } else {
            return methodTierForTarget(dataType, method) === "PrimaryTransform";
          }
        }));
  var other = Belt_List.keep(methods, (function (method) {
          if (method !== selected) {
            return methodTierForTarget(dataType, method) === "OtherTransform";
          } else {
            return false;
          }
        }));
  return [
          primary,
          other
        ];
}

function literalInputKindForTarget(fieldOptions, targetKind, targetField) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByTarget(fieldOptions, targetKind, targetField);
  if (field === undefined) {
    return "TextLiteral";
  }
  var match = field.dataType;
  switch (match) {
    case "DateType" :
        return "DateLiteral";
    case "ListType" :
        if (field.listOptions.length !== 0) {
          if (isBooleanLikeList(field.listOptions)) {
            return {
                    TAG: "BooleanLiteral",
                    _0: field.listOptions
                  };
          } else {
            return {
                    TAG: "ListLiteral",
                    _0: field.listOptions
                  };
          }
        } else {
          return "TextLiteral";
        }
    case "NumberType" :
        return "NumberLiteral";
    default:
      return "TextLiteral";
  }
}

function listOptionsForPath(fieldOptions, path) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByPath(fieldOptions, path);
  if (field !== undefined) {
    return field.listOptions;
  } else {
    return [];
  }
}

function literalValueIncomplete(fieldOptions, targetKind, targetField, valueLiteral) {
  if (targetField.trim() === "") {
    return false;
  }
  var match = literalInputKindForTarget(fieldOptions, targetKind, targetField);
  if (typeof match !== "object") {
    return false;
  } else {
    return valueLiteral.trim() === "";
  }
}

function dateDiffPreviewText(fromPath, toPath, simulationInputs) {
  var match = Js_dict.get(simulationInputs, fromPath);
  var match$1 = Js_dict.get(simulationInputs, toPath);
  if (match === undefined) {
    return ;
  }
  if (match$1 === undefined) {
    return ;
  }
  var fromDate = new Date(match);
  var toDate = new Date(match$1);
  if (Number.isNaN(fromDate.valueOf()) || Number.isNaN(toDate.valueOf())) {
    return ;
  }
  var diffMs = Math.abs(toDate.valueOf() - fromDate.valueOf());
  var days = Js_math.floor_int(diffMs / 86400000);
  return String(days) + " days";
}

var transformMethods = {
  hd: "LookupTable",
  tl: {
    hd: "DateDiffDays",
    tl: /* [] */0
  }
};

exports.transformMethods = transformMethods;
exports.newLookupRow = newLookupRow;
exports.parseLookupMapText = parseLookupMapText;
exports.serializeLookupMapRows = serializeLookupMapRows;
exports.ensureLookupRows = ensureLookupRows;
exports.isLookupRowEmpty = isLookupRowEmpty;
exports.canRemoveLookupRow = canRemoveLookupRow;
exports.removeLookupRowAt = removeLookupRowAt;
exports.lookupCompleteRows = lookupCompleteRows;
exports.lookupPartialRows = lookupPartialRows;
exports.lookupDuplicateSources = lookupDuplicateSources;
exports.lookupHasValidMappings = lookupHasValidMappings;
exports.templateTokenRe = templateTokenRe;
exports.parseTemplateParts = parseTemplateParts;
exports.templateHumanPreview = templateHumanPreview;
exports.templateInvalidPaths = templateInvalidPaths;
exports.presetToMatchType = presetToMatchType;
exports.matchTypeToPreset = matchTypeToPreset;
exports.extractPresetLabel = extractPresetLabel;
exports.escapeRegex = escapeRegex;
exports.applyExtractPreset = applyExtractPreset;
exports.compilePresetPattern = compilePresetPattern;
exports.compileExtractPattern = compileExtractPattern;
exports.currentExtractPreset = currentExtractPreset;
exports.legacySimplePatternSummary = legacySimplePatternSummary;
exports.extractWorkedExample = extractWorkedExample;
exports.targetDataType = targetDataType;
exports.isBooleanLikeList = isBooleanLikeList;
exports.methodTierForTarget = methodTierForTarget;
exports.uncommonMethodMessage = uncommonMethodMessage;
exports.partitionTransformMethods = partitionTransformMethods;
exports.literalInputKindForTarget = literalInputKindForTarget;
exports.listOptionsForPath = listOptionsForPath;
exports.literalValueIncomplete = literalValueIncomplete;
exports.dateDiffPreviewText = dateDiffPreviewText;
/* templateTokenRe Not a pure module */
